<template>
<div class="discount-code">
  <div v-if="(showInput && discountObj && Object.keys(discountObj).length) || (!showInput && discountActive)" class="discount-applied">
    <span class="discount-token">{{discountObj.token}} </span>
    <span v-if="discountActive">discount code applied. </span>
    <span v-if="!discountActive && showInput">discount code not applied. </span>
    <span v-if="discountObj.amount_reduced && discountActive">{{`$${discountObj.amount_reduced / 100} off per person`}}{{ discountDuration }}.</span>
    <span v-if="discountObj.percentage_reduced && discountActive">{{`${discountObj.percentage_reduced}% off`}}{{ discountDuration }}.</span>
    <span v-if="discountFailureReason && showInput"> {{ discountFailureReason}}</span>
    <div class="icon-clear">
      <svg @click.prevent="$store.commit('setDiscount', {})" class="close" data-v-20f4c42f="" width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" ><g stroke="none" stroke-width="1"><path d="M8.99734389,7.08578644 L16.0684117,0.0147186258 L17.4826253,1.42893219 L10.4115575,8.5 L17.5536931,15.6421356 L16.1394795,17.0563492 L8.99734389,9.91421356 L1.92627608,16.9852814 L0.512062518,15.5710678 L7.58313033,8.5 L0.58313033,1.5 L1.99734389,0.0857864376 L8.99734389,7.08578644 Z"></path></g></svg>
    </div>
  </div>
  <div v-if="showInput && !(discountObj && Object.keys(discountObj).length)" class="add-discount-container">
    <div class="open-add-discount" v-if="!displayDiscountAdd" @click.prevent="displayDiscountAdd = true">
      {{ $t("message.add-discount-code") }}
    </div>
    <div v-else class="input-add-discount">
      <input
        v-model="discountInput"
      />
      <div class="buttons discount-submit">
        <a
          @click.prevent="$store.dispatch('tryDiscountCode', discountInput)"
          class="lp-btn lp-btn-primary apply"
          >{{ $t("message.apply-discount") }}
        </a>
      </div>
    </div>
  </div>
</div>
</template>

<style lang="less" scoped>
  .discount-code {
    margin: 0 0 .5em 0;
    .discount-applied {
       border: 1px solid #5c95ba;
       border-radius: 2px;
       background-color: lighten(#5c95ba, 40%);
       padding: 0.8em 2.25em 0.9em 0.65em;
       display: block;
       margin: 0.3em 0 1em 0;
       position: relative;
       .icon-clear {
        cursor: pointer;
        display: flex;
        align-items: center;
        height: 100%;
        position: absolute;
        right: 0px;
        top: 0px;
        padding: 0 10px 5px;
        fill: darken(#5c95ba, 10%);
        font-size: 1.15em;
      }
      &:hover{
        .icon-clear {
          fill: darken(#5c95ba, 20%);
        }
      }
    }
    .discount-token {
      text-transform: capitalize;
    }
    .discount-strikethrough {
      text-decoration: line-through;
    }
    .add-discount-container {
      margin-top: 0;
      .input-add-discount {
        height: 2.8em;
        display: flex;
        margin-top: 0.6em;
        input {
          width: 100%;
          padding: 11px 35px 13px 15px;
          border-radius: 5px;
          background: white;
          border: 1px solid #ccc;
          border-radius: 4px;
        }
        .discount-submit {
          flex-shrink: 0;
          margin: 0 0 0 15px;
        }
      }
      .open-add-discount {
        color: #666;
        text-decoration: underline;
        margin-top: 0em;
        display: block;
        cursor: pointer;
        &:hover {
          color: rgba(0, 0, 0, 1);
        }
      }
    }
    .apply {
      margin: 0;
    }
  }
</style>

<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
      discountInput: null,
      displayDiscountAdd: false,
    }
  },
  props: {
    showInput: {
      default: true
    }
  },
  computed: {
    discountDuration() {
      let count, period;
      let pricingPeriod = this.$store.state.payment.pricingPeriod;
      if (pricingPeriod === 'monthly' && this.discountObj.valid_for_months) {
        count = this.discountObj.valid_for_months;
        period = 'month';
      } else if (pricingPeriod === 'annual' && this.discountObj.valid_for_years) {
        count = this.discountObj.valid_for_years;
        period = 'year';
      }
      if (count) {
        if (count > 1) {
          period = ' ' + period + 's';
        }
        else {
          count = '';
        }
        return ' for your first ' + count + period;
      }
    },
    ...mapState({
      discountObj: state => state.payment.discount,
      currentSubscription: state => state.payment.currentSubscription
    }),
    ...mapGetters(["discountActive", "discountFailureReason"]),
  },
  watch: {
    discountObj(discountObj) {
      if (discountObj && Object.keys(discountObj).length) {
        this.displayDiscountAdd = true;
      }
    }
  }
}
</script>
